var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavIcon4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.43 15.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,7.86c0-1.32,0-2.65,0-3.97C0,1.94,1.39,.33,3.31,.04,3.48,.02,3.66,0,3.83,0c2.56,0,5.13,0,7.69,0,1.87,0,3.41,1.24,3.81,3.06,.05,.25,.08,.51,.08,.76,0,2.69,0,5.38,0,8.06,0,2.09-1.69,3.81-3.78,3.83-2.5,.02-5,0-7.5,0-.47,0-.93-.03-1.38-.16C1.18,15.1,.04,13.64,.01,11.99c-.02-1.38,0-2.75,0-4.13h0Zm14.22,0h-.01c0-1.21,.04-2.43,0-3.64-.06-1.65-1.54-3.01-3.19-3.01-2.19,0-4.38,0-6.57,0-.24,0-.49,.03-.73,.09-1.51,.37-2.51,1.65-2.51,3.2,0,2.23,0,4.47,0,6.7,0,1.82,1.42,3.28,3.25,3.29,2.19,.01,4.37,.01,6.56,0,1.78,0,3.22-1.46,3.22-3.24,0-1.13,0-2.26,0-3.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.66,7.88c0,2.18-1.79,3.95-3.96,3.94-2.18-.01-3.94-1.78-3.93-3.97,0-2.19,1.78-3.95,3.98-3.93,2.17,.01,3.92,1.79,3.91,3.96Zm-1.04,0c0-1.64-1.29-2.98-2.89-2.98-1.61,0-2.92,1.33-2.92,2.97,0,1.62,1.3,2.97,2.89,2.97,1.61,0,2.92-1.32,2.92-2.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.99,3.77c0,.65-.54,1.18-1.18,1.17-.67,0-1.19-.53-1.19-1.18,0-.66,.53-1.18,1.19-1.18,.66,0,1.18,.53,1.18,1.19Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon4);
export default __webpack_public_path__ + "static/media/nav-icon4.630e57bf0f14e2eab0ef162b70eabac4.svg";
export { ForwardRef as ReactComponent };